import { render, staticRenderFns } from "./userApp.vue?vue&type=template&id=4fc3a64d&scoped=true&"
import script from "./userApp.vue?vue&type=script&lang=js&"
export * from "./userApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3a64d",
  null
  
)

export default component.exports